import { render, staticRenderFns } from "./EpcArrayFlanders.vue?vue&type=template&id=48a04aaa&scoped=true&"
import script from "./EpcArrayFlanders.vue?vue&type=script&lang=js&"
export * from "./EpcArrayFlanders.vue?vue&type=script&lang=js&"
import style0 from "./EpcArrayFlanders.vue?vue&type=style&index=0&id=48a04aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a04aaa",
  null
  
)

export default component.exports